module.exports = __webpack_public_path__ + "assets/img/delete2.382eb5cc.svg";